import React from 'react'
import { useParams } from 'react-router-dom'
import { Box, CircularProgress, Alert } from '@mui/material'
import { useGetFormSubmissionQuery } from '@/core/services/form'
import ViewFormSubmission from '../components/ViewFormSubmission'
import { useGenerateFilledPdf } from '@/features/form-submission/model/useGenerateFilledPdf'

const ViewFormSubmissionContainer: React.FC = () => {
    const { submissionId = '' } = useParams()
    const { data: submission, isLoading, error } = useGetFormSubmissionQuery(submissionId)
    const { handleGeneratePdf, isGeneratingPdf } = useGenerateFilledPdf()

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <CircularProgress />
            </Box>
        )
    }

    if (error || !submission) {
        return (
            <Alert severity="error">
                Error loading form submission. Please try again later.
            </Alert>
        )
    }

    return (
        <ViewFormSubmission
            submission={submission}
            onGeneratePdf={() => handleGeneratePdf(submissionId)}
            isGeneratingPdf={isGeneratingPdf}
        />
    )
}

export default ViewFormSubmissionContainer 